import React from 'react';
import { formatMinistryMonthLabel } from '../../utils/mbcbReportPeriodLabels';

interface StepWelcomeProps {
  ministryMonth: number;
  ministryYear: number;
  churchName?: string | null;
  onStart: () => void;
  needsRevision?: boolean;
}

export const StepWelcome: React.FC<StepWelcomeProps> = ({
  ministryMonth,
  ministryYear,
  churchName,
  onStart,
  needsRevision,
}) => {
  const ministryLabel = formatMinistryMonthLabel(ministryMonth, ministryYear);

  return (
    <div className="flex-1 flex flex-col items-center justify-center px-6 py-8 text-center animate-fade-in">
      <div className="w-20 h-20 rounded-full bg-gradient-to-br from-primary-100 to-primary-200 flex items-center justify-center mb-6">
        <svg className="w-10 h-10 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
          />
        </svg>
      </div>
      <h2 className="text-2xl font-bold text-gray-900 leading-tight">
        {needsRevision ? 'Let\u2019s update your report' : 'Let\u2019s celebrate what God did'}
      </h2>
      <p className="mt-3 text-gray-600 max-w-sm leading-relaxed">
        {needsRevision
          ? `Your team asked for a few updates to your ${ministryLabel} report.`
          : `Share the story of ${ministryLabel}${churchName ? ` at ${churchName}` : ''} — your reflections come first, then a light snapshot of numbers.`}
      </p>
      <button
        type="button"
        onClick={onStart}
        className="mt-8 w-full max-w-xs py-4 rounded-2xl bg-primary-600 text-white text-base font-semibold hover:bg-primary-700 shadow-lg shadow-primary-600/20 min-h-touch transition-colors"
      >
        {needsRevision ? 'Continue updating' : `Reflect on ${ministryLabel}`}
      </button>
      <p className="mt-4 text-xs text-gray-400">Takes about 5–10 minutes · Saves automatically</p>
    </div>
  );
};
